import TopNav from "@/components/v2/top-nav";
import React, { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Drawer, useOverlayState } from "@heroui/react";
import { getDocsSectionsArr } from "@/config/docs-config";
import { ArrowRight, User } from "lucide-react";
import BackgroundBlobs from "@/components/ui/background-blobs";

const DOCS_SECTIONS_ARR = getDocsSectionsArr()

const SideNavItem = ({ section, onClick }) => {
  const { pathname } = useLocation();
  const isActive = pathname === `/docs/${section.url}`;
  const Icon = section.icon || User;
  return (
    <button
      onClick={onClick}
      className={`w-full rounded-xl text-left flex items-center gap-2.5 px-3 py-2.5 transition-colors group
        ${isActive
          ? "bg-white/20 text-white font-semibold"
          : "text-white hover:text-white hover:bg-white/10"
        }`}
    >
      <Icon className="h-4 w-4 shrink-0" />
      <span className="text-sm">{section.label}</span>
    </button>
  );
};

const DocsLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const menuState = useOverlayState({
    isOpen: menuOpen,
    onOpenChange: (isOpen) => { if (!isOpen) setMenuOpen(false); },
  });

  return (
    <div className="relative h-screen max-h-screen overflow-hidden w-full flex flex-col">
      <nav className="shrink relative z-10">
        <TopNav menuIcon onMenuOpen={() => setMenuOpen(true)}/>
      </nav>

      <div className="flex flex-1 min-h-0 relative z-10">
        {/* Desktop side nav */}
        {/* <aside className="hidden lg:flex flex-col w-56 shrink-0 px-4 py-6 gap-1 bg-white/10 backdrop-blur-[10px]   border-r border-white/10">
           <SideNavItem
              key={'ho'}
              section={section}
              onClick={() => navigate(`/docs`)}
            />
          {DOCS_SECTIONS_ARR.map((section) => (
            <SideNavItem
              key={section.id}
              section={section}
              onClick={() => navigate(`/docs/${section.url}`)}
            />
          ))}
        </aside> */}

        <main className="flex-1 overflow-auto px-6 lg:px-24 py-6">
          <Outlet />
        </main>
      </div>

      {/* Mobile drawer */}
      <Drawer state={menuState}>
        <Drawer.Backdrop variant="blur" className="bg-black/30 z-[200]">
          <Drawer.Content placement="left" className="z-[200] max-w-xs w-full">
            <Drawer.Dialog>
              <Drawer.Header className="border-b pb-4">
                <Drawer.Heading className="font-semibold text-base">Loopp API Documentation</Drawer.Heading>
              </Drawer.Header>
              <Drawer.Body className="pt-6">
                <div className="flex flex-col lg:gap-6 gap-3">
                  {DOCS_SECTIONS_ARR.map((section) => {
                    const Icon = section.icon || User;
                    return (
                      <button
                        key={section.id}
                        onClick={() => { navigate(`/docs/${section.url}`); setMenuOpen(false); }}
                        className="dark:border-white/30 cursor-pointer rounded-xl text-left flex flex-col gap-1.5 hover:bg-black/20! transition-colors group"
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <div className="p-2 rounded-lg bg-accent/15">
                              <Icon className="text-accent h-4 w-4" />
                            </div>
                            <span className="font-semibold text-base">{section.label}</span>
                          </div>
                          <ArrowRight className="h-4 w-4 text-black/30 group-hover:text-accent group-hover:translate-x-0.5 transition-all" />
                        </div>
                        <span className="text-black/40 dark:text-white/60 text-xs leading-relaxed">{section.description}</span>
                      </button>
                    );
                  })}
                </div>
              </Drawer.Body>
            </Drawer.Dialog>
          </Drawer.Content>
        </Drawer.Backdrop>
      </Drawer>

      <div className="bg-white/5 h-screen w-screen z-2 backdrop-blur-[100px] absolute inset-0 top-0 left-0 right-0" />
      <BackgroundBlobs />
    </div>
  );
};

export default DocsLayout;
